<template>
  <div>
    <div v-if="step == 0" class="flex">
      <button
        @click.prevent="addProduct()"
        class="mx-auto text-primary transition-all duration-500 ease-in-out transform hover:scale-95 flex justify-center items-center"
      >
        <AddIcon class="w-5 fill-current text-primary" /> Add a Product
      </button>
    </div>
    <div v-else-if="step == 1">
      <div class="px-4">
        <div class="flex flex-wrap">
          <div class="w-1/6 flex items-center justify-end pr-4">
            <p class="text-sm">Select a product:</p>
          </div>
          <div class="w-3/6">
            <Multiselect
              v-model="selected"
              id="ajax"
              label="name"
              track-by="id"
              placeholder="Type to search"
              open-direction="top"
              :options="options"
              :searchable="true"
              :loading="ui.loading"
              :internal-search="true"
              :clear-on-select="true"
              :close-on-select="true"
              :options-limit="300"
              :option-height="104"
              :max-height="200"
              :show-no-results="false"
              @search-change="searchProducts"
            >
              <template slot="singleLabel" slot-scope="props">
                <div class="flex flex-wrap items-center">
                  <template>
                    <img
                      v-if="props.option.image"
                      class="w-1/12 shadow-xs rounded"
                      :src="props.option.image"
                    />
                    <div
                      v-else
                      class="w-1/12 shadow-xs rounded bg-gray-300 py-2 px-1 break-words"
                    >
                      <p class="text-xs text-center leading-none">No image</p>
                    </div>
                  </template>
                  <div class="w-11/12 pl-4">
                    <p class="text-base">
                      {{ props.option.name }}
                    </p>
                    <p class="text-sm truncate">
                      {{ props.option.description }}
                    </p>
                  </div>
                </div>
              </template>
              <template slot="option" slot-scope="props">
                <div class="flex flex-wrap items-center">
                  <div class="w-12/12">
                    <p class="text-base">
                      {{ props.option.name }}
                    </p>
                    <p class="text-sm truncate">
                      {{ props.option.description }}
                    </p>
                  </div>
                </div>
              </template>
            </Multiselect>
          </div>
          <div class="w-1/6 flex justify-center">
            <button
              @click.prevent="select()"
              :class="{ 'bg-primary': selected, 'bg-gray-600': !selected }"
              :disabled="!selected"
              class="h-full px-8 rounded transition-all duration-500 ease-in-out transform hover:scale-95"
            >
              <p class="leading-none text-white text-xs font-semibold">
                Select
              </p>
            </button>
          </div>
          <div class="w-1/6 flex justify-center">
            <button
              @click.prevent="cancel()"
              class="bg-gray-600 h-full px-8 rounded transition-all duration-500 ease-in-out transform hover:scale-95"
            >
              <p class="leading-none text-white text-xs font-semibold">
                Cancel
              </p>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { searchProducts } from "~/api";

export default {
  name: "ProductsAddNewProduct",

  props: {
    groupIndex: {
      required: true
    }
  },

  data() {
    return {
      ui: {
        loading: false,
        success: false,
        error: null
      },

      step: 0,

      options: [],

      selected: null
    };
  },

  methods: {
    addProduct() {
      this.step = 1;
    },

    searchProducts(query) {
      if (query !== '' && query.length >= 3) {
        this.ui.loading = true;
        this.clearOptions();

        searchProducts(query)
          .then(response => {
            this.options = response;
          })
          .finally(() => {
            this.ui.loading = false;
          });
      } else {
        this.options = []
      }
    },

    clearOptions() {
      this.options = [];
    },

    isValidBase64(string) {
      try {
        window.atob(string);
        return true;
      } catch (e) {
        return false;
      }
    },

    select() {
      this.step = 0;

      this.$emit("select-product", this.groupIndex, this.selected);

      this.clear();
    },

    cancel() {
      this.step = 0;
      this.selected = null;
      this.options = [];
    },

    clear() {
      this.selected = null;
      this.options = [];
    }
  }
};
</script>
